export enum officeType {
  MAIN = "Main Office",
  SUB = "Sub Office",
}
